/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
* C block for DEMs
*/

const Blockly = require('blockly');
require('blockly/python');
const AreaService = require('../../services/area.service').AreaService;
const getAllowedStatements = require('../block_compatibility_checks').getAllowedStatements;
import { areaChange } from '../helper_functions';

Blockly.Blocks['input_dem_data'] = {
    init: function () {
        let areas = AreaService.getAreas();
        this.appendDummyInput('area_input')
            .appendField('DEM: ')
            .appendField(new Blockly.FieldDropdown([['SRTM 30m DEM', 'srtm_dtm'], ['GMTED 2010', 'gmted_dtm'], ['ALOS 30m DSM', 'alos_dsm']]), "dropdown")
            .appendField("Area: ")
            .appendField(new Blockly.FieldDropdown(areas), "area")
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('dem'))
        this.setInputsInline(false);
        this.setStyle('terrain');
        this.setTooltip(Blockly.Msg.DEM_BLOCK_TOOLTIP);
        this.setHelpUrl("");

        this.areaSubscription = AreaService.areaChange$.subscribe( () => {
            let result = areaChange(this, "area_input", "area");
            if(!result) {
                this.areaSubscription.unsubscribe();
            }
        });
    },
    
};